<template>
<div v-if="helpModalVisible" class="report-modal-wrapper">
  <div class="report-modal-container">
    <div class="report-modal">
      <div style="float: right;"><button @click.prevent="setHelpModalVisible(false)"><img src="img/close-icon.svg" /></button></div>
      <h2 class="title">How to Use</h2>
      <div>
        <h3>About the Tool</h3>
        <p>ReadyMapper is a digital tool that puts important disaster-related information in one place, making it easier and faster for emergency response teams to coordinate and deliver aid where it’s needed most.</p>

        <h3>Functionalities & Uses</h3>
        <h4>Select Disaster Type</h4>
        <ul>
          <li>Choose the disaster type and specific event from the left pane</li>
        </ul>

        <h4>Select Geographical Areas of Interest</h4>
        <ul>
          <li>Once the event data loads, navigate around the zoomed in Area of Interest to understand the extent of the disaster impact</li>
          <li>Access pre-loaded data at the ACS place-level for US specific disasters and GADM Admin 2 level for international disasters.</li>
          <li>Switch to ACS County or GADM Admin 1 for aggregate statistics using the bottom left panel</li>
          <li>Press play on the time-slider on top of the screen to see how the disaster progresses over time.</li>
        </ul>

        <h4>View Community Vulnerability Data</h4>
        <ul>
          <li>Gain insights into community vulnerability through metrics like elderly population percentage and poverty levels.</li>
          <li>View detailed information on power outages, both overall and at the place level. Power outages are primarily available for US specific disasters</li>
          <li>A table will display changes in power outages as the disaster progresses.</li>
        </ul>

        <h4>Analyze Population Movement</h4>
        <ul>
          <li>Use the map to see where people are moving during a disaster.</li>
          <li>Red dots show decreasing populations; blue dots indicate increasing populations.</li>
          <li>Yellow dots represent areas with below-average population movement.</li>
          <li>Press play to see how population densities change over time.</li>
          <li>This helps identify where to allocate resources and deliver aid.</li>
        </ul>

        <h4>Local Population Movement Analysis: Utilizing Side Panel Controls</h4>
        <ul>
          <li>Select your desired location and timeframe and then analyze directional population flows with the 'To/From' toggle feature available in the side panel.</li>
          <li>Observe percentage change in population density on the table</li>
        </ul>

        <h4>Assess Infrastructure and Healthcare Capacities</h4>
        <ul>
          <li>View locations of healthcare facilities in the chosen area.</li>
          <li>Different symbols and colors indicate facility types and capacities.</li>
          <li>Click on a place or county to visualize an overlay showing driving distances to healthcare facilities. Currently available for US specific disasters</li>
        </ul>

        <h4>Create and Share a Custom Report</h4>
        <ul>
          <li>Select areas of interest and generate tailored reports using the "Generate Report" feature</li>
          <li>Customize the report's content and order based on your needs.</li>
          <li>Add a summary at the top for an overview of key findings.</li>
          <li>Save, share, or print the report as needed.</li>
        </ul>

        <h4>Access Historical Data</h4>
        <ul>
          <li>View past disaster data to identify patterns and improve future preparedness.</li>
        </ul>

      </div>

      <h3>Get in touch</h3>
      <p>Contact us at <a href="mailto:info@crisisready.io">info@crisisready.io</a>.</p>
      <Logos />
    </div>
  </div>
</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Logos from './Logos'

export default {
  name: 'HelpModal',

  components: {
    Logos,
  },

  computed: {
    ...mapState([
      'helpModalVisible'
    ]),
  },

  watch: {
    helpModalVisible(newValue) {
      console.log('helpModalVisible changed:', newValue);
    }
  },

  methods: {
    ...mapMutations([
      'setHelpModalVisible',
    ]),
  },
}
</script>

<style lang="scss" scoped>
.report-modal-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(15, 47, 128, 0.3);
  z-index: 1000;
}

.report-modal-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.report-modal {
  height: fit-content;
  max-width: 600px;
  min-width: 300px;
  max-height: 80vh;
  overflow-y: auto;
  background: #F9FCFE;
  box-shadow: 0px 0px 8px rgba(73, 73, 73, 0.25);
  padding: 23px 25px;
  border-radius: 6px;
  text-align: left;

  .title {
    margin-top: 0;
    padding-bottom: 0;
  }

  h3, h4 {
    margin-bottom: 0.5em;
  }

  ul {
    list-style-type: none;
    padding-left: 1em;
  }

  li {
    margin-bottom: 0.5em;
  }

  .pill {
    border: none;
    margin-bottom: 1em;
    border-radius: 1em;
    background: #d7e2fd;
    color: #0f2f80;
    padding: 0.5em 1em;
    font-weight: bold;
    font-size: 0.9em;
  }

  .gray {
    background: #c1c1c1;
    color: #8e8e8e;
  }

  .add {
    border: 2px solid #0f2f80;
    background: none !important;
  }

  .buttons {
    flex-direction: row;
    display: flex;
    margin-top: 1em;

    .primary {
      border: 2px solid #0f2f80;
      color: #0f2f80;
    }
    .close {
      border: 2px solid #545454;
      color: #333;
    }

    :not(:last-child) {
      margin-right: 1em;
    }

    a {
      text-decoration: none;
      font-size: 0.9em;
      font-weight: bold;
      width: 100%;
      padding: 0.75em 1em;
      text-align: center;
    }
  }
}
.pointer {
  cursor: pointer;
}
</style>
